export enum TranslationsKeys {
  // Olds
  OLD_TRANSLATIONS = 'translation',
  // Globals
  TERMS = 'terms',
  COMMON = 'common',
  // Layouts
  AUTHORIZED_LAYOUT = 'layouts.authorized',
  // learning-result
  LEARNING_RESULT_LIST = 'learning-result/list',
  LEARNING_RESULT_ASSOCIATE = 'learning-result/associate',
  // classes-book
  CLASSES_BOOK_LIST = 'classes-book/list',
  CLASSES_BOOK_EDIT = 'classes-book/edit',
  // courses
  COURSES_LIST = 'courses/list',
  COURSES_DETAILS = 'courses/details',
  // Petitions
  PETITIONS = 'grade-replacement-petitions/list',
  // teacher-schedule
  TEACHER_SCHEDULE = 'teacher-schedule/list',
  STUDENT_FILE = 'student-file/list',
  STUDENT_FILE_TABS = 'student-file/tabs',
  STUDENT_FILE_PERSONAL_INFORMATION = 'student-file/personal-information',
  STUDENT_FILE_EDUCATIONAL_BACKGROUND = 'student-file/educational-background',
  STUDENT_FILE_ACADEMIC_HISTORY = 'student-file/academic-history',
  STUDENT_FILE_PETITION = 'student-file/petition',
  // announcements
  ANNOUNCEMENTS_LIST = 'announcements/list',
  //teacher-attendance
  TEACHER_ATTENDANCE_LIST = 'teacher-attendance/list',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
